/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { DefinitionListProps } from './index';

/**
 * Base styles for the DefinitionList component
 */
const baseStyles = ({ definitions }: DefinitionListProps) => css`
    display: grid;
    grid-template-columns: 1.5fr 1fr;
    margin: 0 0 var(--layout-spacing-24);
    border-top: 1px solid var(--colors-border-tertiary);

    dt,
    dd {
        padding: 1rem 0;
        margin: 0;
        border-bottom: 1px solid var(--colors-border-light);

        &:last-of-type {
            border-bottom: 1px solid var(--colors-border-tertiary);
        }
    }

    dd {
        ${theme.typography.body_normal};
        text-align: right;

        ${definitions.map((definition, i) => {
            const index = i + 1;
            return css`
                &:nth-of-type(${index}) {
                    -ms-grid-row: ${index};
                    -ms-grid-column: 2;
                }
            `;
        })};
    }

    dt {
        padding-top: 1.4rem;
        padding-right: 1rem;
        text-transform: capitalize;
        ${theme.typography.body_normal_highlight};
        line-height: 1.5rem;

        ${definitions.map((definition, i) => {
            const index = i + 1;
            return css`
                &:nth-of-type(${index}) {
                    -ms-grid-row: ${index};
                    -ms-grid-column: 1;
                }
            `;
        })};
    }
`;

/**
 * The DefinitionList component styles
 *
 * @param {DefinitionListProps} props The definition-list properties object
 */
export const styles = (props: DefinitionListProps) => css`
    ${baseStyles(props)}
`;
